var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import SalesWarningPopup from "../../../shared-library/components/SalesWarningPopup";
import { useSelector } from "react-redux";
import { getDaysDifference } from "@domains/utils/reportDates";
import moment from "moment";
import { LogoLoader } from "../../../shared-library/components/Loader";
import leadDi from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
var ClientProfileUpdatePopup = function (props) {
    var _a = __read(React.useState(false), 2), cancelProfileUpdateLoader = _a[0], setCancelProfileUpdateLoader = _a[1];
    var userId = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Profile.ProfileDetails.reducersData.data) === null || _a === void 0 ? void 0 : _a.profileDetails) === null || _b === void 0 ? void 0 : _b.userId; });
    var clientProfileDetails = useSelector(function (state) {
        return state.Lead.ClientProfileDetails.reducersData.clientProfileDetails;
    });
    var routeToViewProfile = function () {
        var url = new URL(process.env.VIEW_PROFILE_IMAGE);
        url.searchParams.append("AcCode", props === null || props === void 0 ? void 0 : props.clientId);
        url.searchParams.append("LoginId", userId === null || userId === void 0 ? void 0 : userId.toString());
        props.setShowPopUp(false);
        window.open(url.toString(), "_blank");
    };
    var handleCancelProfileUpdate = function () {
        setCancelProfileUpdateLoader(true);
        leadDi.leads
            .clientProfileUpdate({
            accode: props.clientId,
            respose: "N",
        })
            .then(function (data) {
            if (data.data) {
                props.setShowPopUp(false);
                setCancelProfileUpdateLoader(false);
            }
        })
            .catch(function (err) {
            props.setShowPopUp(false);
            setCancelProfileUpdateLoader(false);
        });
    };
    React.useEffect(function () {
        if (clientProfileDetails &&
            (clientProfileDetails === null || clientProfileDetails === void 0 ? void 0 : clientProfileDetails.isShowProfileUpdatePopUp) &&
            (clientProfileDetails === null || clientProfileDetails === void 0 ? void 0 : clientProfileDetails.responsedate)) {
            if (getDaysDifference(moment(clientProfileDetails === null || clientProfileDetails === void 0 ? void 0 : clientProfileDetails.responsedate).toDate(), moment().toDate()) > 60) {
                props.setShowPopUp(true);
                props.setProfileOverview && props.setProfileOverview(false);
            }
        }
        else if (clientProfileDetails &&
            (clientProfileDetails === null || clientProfileDetails === void 0 ? void 0 : clientProfileDetails.isShowProfileUpdatePopUp) &&
            clientProfileDetails.lastprofilingDate) {
            if (getDaysDifference(moment(clientProfileDetails === null || clientProfileDetails === void 0 ? void 0 : clientProfileDetails.lastprofilingDate).toDate(), moment().toDate()) > 180) {
                props.setShowPopUp(true);
                props.setProfileOverview && props.setProfileOverview(false);
            }
        }
        else {
            props.setShowPopUp(false);
        }
    }, [clientProfileDetails]);
    return (React.createElement(SalesWarningPopup, { size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist commonmodal sales-client lead-warning", title: "", showFooter: true, show: props.showPopUp, setShow: function () { return props.setShowPopUp(); }, showCloseIcon: true, closeicon: "edel-icon-cross", closeDropdown: function () { return handleCancelProfileUpdate(); }, children: React.createElement(React.Fragment, null,
            cancelProfileUpdateLoader && React.createElement(LogoLoader, null),
            React.createElement("div", { className: "DMSans_16_500 txt_primaryGrey line-140" }, "It's been a long time since your client's profile was last updated, do you wish to update the profiler now?")), btnvalueleft: {
            value: "Yes",
            btnTyp: "midnight-blue",
            onClick: function (e) { return routeToViewProfile(); },
        }, btnvalueright: {
            value: "No",
            btnTyp: "midnight-blue-border",
            onClick: function (e) { return handleCancelProfileUpdate(); },
        }, handleOutsideClick: function () { return handleCancelProfileUpdate(); } }));
};
export default ClientProfileUpdatePopup;
